import React , {useEffect} from 'react'
import { useDispatch } from 'react-redux';
import { addAboutData } from '../Utils/DataSlice';
function useGetAboutData() {
    const baseURL = process.env.REACT_APP_BASE_URL;
  const dispatch = useDispatch();
    const getAboutdata = (params) => {
        const query = new URLSearchParams(params).toString(); // convert object to query string
        fetch(`${baseURL}/main-website/get-landing-data?${query}`)
          .then((res) => res.json())
          .then((result) => {
            dispatch(addAboutData(result));
          });
      };

      useEffect(() => {
        getAboutdata({ page: "AboutUs" }); // example params
      }, []);
      
      
}

export default useGetAboutData